// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=JetBrains+Mono:ital,wght@0,100..800;1,100..800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RquHA{font-family:"Inter",sans-serif;border:2px solid rgba(0,0,0,0);border-radius:.9375rem;background-color:#0078d4;color:#fff;font-size:15px;font-weight:600;padding:13px 25px;cursor:pointer;text-transform:none;min-width:220px}
.twOAp{font-family:"Inter",sans-serif}
.g_WMS{background-color:#fff;border-radius:16px 16px 0 0;font-family:"Inter",sans-serif;top:-8px;position:relative;padding-top:48px;padding-bottom:24px;-webkit-box-shadow:0 -4px 20px -4px rgba(0,0,0,.04);box-shadow:0 -4px 20px -4px rgba(0,0,0,.04)}
.NXfdR{font-weight:700;font-size:28px;color:#0f172a;letter-spacing:-0.5px;line-height:1.3;margin-bottom:0}
.cFe02{margin-top:12px;font-weight:400;font-size:16px;color:#64748b;letter-spacing:-0.1px;line-height:1.6;margin-left:auto;margin-right:auto}
.twOAp{background-color:#fff;padding-top:24px;border-radius:12px}
.Nt4Sr{color:#334155}
.LpGS5{font-size:22px;font-weight:700}
.En6OH{color:#94a3b8;font-size:18px;font-weight:500}
.wloZX{border-radius:12px;border:1px solid #e2e8f0;padding:25px}
.c3mtQ{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;gap:16px}
.WOhlt{display:grid;grid-template-columns:99px minmax(0, 1fr) auto;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-column-gap:3rem;-moz-column-gap:3rem;column-gap:3rem;min-height:96px;width:100%;margin:0}
.Z5V7D{grid-template-columns:99px minmax(0, 1fr)}
.IIZKl{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;min-width:0}
.e5_uq{min-width:0}
.Ig8e4{justify-self:end}
.rN2vW{color:#64748b;font-size:40px}
.jotbJ{min-width:220px}
.vmaCv{color:#16a34a;font-size:30px;margin-right:10px;vertical-align:middle}
.v6emB{color:#64748b;font-size:14px;font-weight:400}
.aw_6M{background:none;border:none;color:#0078d4;font-size:14px;font-weight:500;cursor:pointer;padding:0;text-decoration:underline}
.aw_6M:hover{color:#005a9e}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"buttonBlue": `RquHA`,
	"baseContainer": `twOAp`,
	"formContainer": `g_WMS`,
	"title": `NXfdR`,
	"subtitle": `cFe02`,
	"textContainer": `Nt4Sr`,
	"elementTitle": `LpGS5`,
	"elementSubTitle": `En6OH`,
	"connectStripeContainer": `wloZX`,
	"optionsStack": `c3mtQ`,
	"optionCard": `WOhlt`,
	"optionCardConnected": `Z5V7D`,
	"leadingArea": `IIZKl`,
	"textCol": `e5_uq`,
	"actionCol": `Ig8e4`,
	"emailIcon": `rN2vW`,
	"actionButton": `jotbJ`,
	"checkIcon": `vmaCv`,
	"alternativeText": `v6emB`,
	"alternativeLink": `aw_6M`
};
module.exports = ___CSS_LOADER_EXPORT___;
